type PlatformType = "tipp" | "checktok" | "trucktour";

export const isPlatformTippspiel =
    (process.env.REACT_APP_PLATFORM as PlatformType) === "tipp";

export const isPlatformChecktok =
    (process.env.REACT_APP_PLATFORM as PlatformType) === "checktok";

export const isPlatformTrucktour =
    (process.env.REACT_APP_PLATFORM as PlatformType) === "trucktour";
